module.exports = __webpack_public_path__ + "static/media/screen-primary-03.5da2475f.jpg";